export const japanMetropolisNatureProgram = {
  programKey: 'japonia-w-rytmie-metropolii-i-natury',

  /* Podstawowe informacje wspólne dla sticky paska i przyszłego katalogu. */
  title: 'Japonia - W rytmie metropolii i natury',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Japonia:',
  stickySubtitle: 'W rytmie metropolii i natury',

  pageUrl:
    'https://coolturystki.pl/wycieczki/japonia-w-rytmie-metropolii-i-natury',

  /*
   * Dane wykorzystywane przez kartę programu i filtry katalogu.
   */
  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-japonii-tokio-fuji-mucfgmvf.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-japonii-tokio-fuji-mucfgmvf.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Japonia'],
    continent: 'Azja',
    categories: [],
    travelStyles: ['Wyjazd objazdowy', 'Egzotyka'],
    catalogPublishedAt: '2026-09-22',
  },

  /* Terminy: 30 marca - 11 kwietnia oraz 20 maja - 1 czerwca 2027. */
  tripIds: [22, 23],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '22': {
      pilotId: 'pawel',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Wspólna podróż rozpoczyna się na Lotnisku Chopina w Warszawie. Lecimy na lotnisko Kansai w Osace z jedną przesiadką, a wracamy do Warszawy z lotniska Narita w Tokio, również z jedną przesiadką.',
        },
        hotel: {
          title: 'Hotele 4★ w Osace i 3★ w Tokio',
          description:
            'Siedem noclegów spędzamy w hotelu 4★ w Osace, a cztery w hotelu 3★ w Tokio. Nocujemy w pokojach 2-osobowych twin z osobnymi łóżkami, a każdy dzień rozpoczynamy od śniadania.',
        },
      },
    },

    '23': {
      pilotId: 'pawel',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Wspólna podróż rozpoczyna się na Lotnisku Chopina w Warszawie. Lecimy na lotnisko Kansai w Osace z jedną przesiadką, a wracamy do Warszawy z lotniska Narita w Tokio, również z jedną przesiadką.',
        },
        hotel: {
          title: 'Hotele 3★ w Osace i Tokio',
          description:
            'Siedem noclegów spędzamy w hotelu 3★ w Osace, a cztery w hotelu 3★ w Tokio. Nocujemy w pokojach 2-osobowych twin z osobnymi łóżkami, a każdy dzień rozpoczynamy od śniadania.',
        },
      },
    },
  },
}
